import { AnyAction } from 'redux';
import { call, put, select, takeEvery } from 'redux-saga/effects';
import { AssessmentPagePayload } from 'types/assessment-payload';
import { abortPageController, getAssessmentPage } from 'api/api';
import {
  checkSelectionAction,
  fetchAssessmentPageErrorAction,
  fetchAssessmentPageStartAction,
  fetchAssessmentPageSuccessAction,
} from 'actions/assessmentPage';
import { GET_ASSESSMENT_PAGE } from 'actions/assessmentPage/types';
import { RootReducer } from 'store/reducers';
import { getAlertByExternalId } from 'store/reducers/assessmentPage/selectors';

const getState = (state: RootReducer) => state;

export function* fetchAssessmentPage({ pageNumber, token }: AnyAction) {
  try {
    yield put(fetchAssessmentPageStartAction());

    abortPageController.abort();

    const { data: currentPage }: { data: AssessmentPagePayload } = yield call(
      getAssessmentPage,
      pageNumber,
      token
    );

    yield put(fetchAssessmentPageSuccessAction(currentPage));

    const state = yield select(getState);
    const externalAlert = yield getAlertByExternalId(state);

    if (externalAlert) {
      yield put(checkSelectionAction(externalAlert.id));
    }
  } catch (e) {
    if (e.response) {
      yield put(
        fetchAssessmentPageErrorAction(
          e.response.data?.message,
          e.response.status
        )
      );
    }
  }
}

export default function* watchFetchAssessmentPage() {
  yield takeEvery(GET_ASSESSMENT_PAGE, fetchAssessmentPage);
}
